var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EEF4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9859 10.608C14.3987 10.6065 12.8536 11.118 11.5817 12.0662V6.625H8.59375V17.9926C8.59375 19.4527 9.02729 20.88 9.83955 22.094C10.6518 23.3081 11.8063 24.2543 13.157 24.813C14.5078 25.3718 15.9941 25.518 17.428 25.2331C18.862 24.9483 20.1791 24.2452 21.2129 23.2128C22.2467 22.1803 22.9508 20.8649 23.236 19.4328C23.5212 18.0008 23.3748 16.5164 22.8153 15.1675C22.2558 13.8185 21.3084 12.6656 20.0927 11.8544C18.8771 11.0432 17.4479 10.6102 15.9859 10.6102V10.608ZM15.9859 22.3888C15.1148 22.3888 14.2633 22.1309 13.539 21.6476C12.8148 21.1643 12.2503 20.4773 11.9169 19.6736C11.5836 18.8699 11.4964 17.9855 11.6663 17.1323C11.8363 16.2791 12.2557 15.4954 12.8716 14.8803C13.4876 14.2652 14.2723 13.8463 15.1267 13.6765C15.981 13.5068 16.8665 13.5939 17.6713 13.9268C18.4761 14.2597 19.1639 14.8235 19.6478 15.5468C20.1318 16.2701 20.3901 17.1205 20.3901 17.9904C20.3901 19.1574 19.9262 20.2766 19.1004 21.1021C18.2746 21.9277 17.1544 22.392 15.9859 22.3932V22.3888Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBqLogo);
export default __webpack_public_path__ + "static/media/icn_bq_logo.33a2602f9cc029bf680a92e87ce803b7.svg";
export { ForwardRef as ReactComponent };